import { render, staticRenderFns } from "./confirmModal.vue?vue&type=template&id=1ff83326&scoped=true&lang=html&"
import script from "./confirmModal.vue?vue&type=script&lang=js&"
export * from "./confirmModal.vue?vue&type=script&lang=js&"
import style0 from "./confirmModal.vue?vue&type=style&index=0&id=1ff83326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff83326",
  null
  
)

export default component.exports